import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ContentApp from '../../../components/ContentApp';
import Header from '../../../components/Common/Header/Header';
import { WelletContext } from '../../../context/WelletContext';
import AccountFilterIcon from '../../../components/icons/AccountFilterIcon';
import Button from '../../../components/Common/Button/Button';
import styles from './GuestList.module.css';
import usaFlag from './usaflag.png';
import check from './check.png';
import Invalid from './Invalid.png';
const GuestList = ({ history }) => {
  const { t } = useTranslation();
  const handleInviteClick = () => {
    history.push('/invite');
  };
  const accounts = [
    { name: 'Matute26', members: 5103, volume: '$0.00', status: 'active' },
    { name: 'Gabylan2025', members: 116, volume: '$4,033,045.57', status: 'active' },
    { name: 'GiorgioP_CBA', members: 10, volume: '$4,033,045.57', status: 'inactive' },
    { name: 'Javivi', members: 1, volume: '$0.00', status: 'active' },
  ];

  return (
    <>
      <Header />

      <ContentApp>
        <div className='d-flex align-items-center justify-content-between gap-3'>
          <div className={styles.connectedTitle}>Connected accounts</div>
          <Button
            Button
            onClick={handleInviteClick}
            size='small'
            width={86}
            className={`${styles.inviteCustomFont}`}
            text={'+' + t('Invite')}
            iconColor='#000'
          />
        </div>

        <div className={styles.cardContainer}>
          <div className={styles.cardBox}>
            <div className={styles.cardTitle}>All accounts</div>
            <div className={styles.cardNumber}>10</div>
          </div>
          <div className={styles.cardBox}>
            <div className={styles.cardTitle}>Pending</div>
            <div className={styles.cardNumber}>0</div>
          </div>
          <div className={styles.cardBox}>
            <div className={styles.cardTitle}>Rejected</div>
            <div className={styles.cardNumber}>0</div>
          </div>
        </div>

        {/* <div className='row mt-3 mb-4'>
          <div className='col-auto pr-0'>
            <div className='account-button'>
              <AccountFilterIcon color='#7E7E7E' size='16px' styles={{ marginTop: '-2px' }} />
            </div>
          </div>
          <div className='col pl-1  px-1'>
            <div
              className={`account-button `}
            >
              {t('All')}
            </div>
          </div>
          <div className='col pl-1  px-1'>
            <div
              className={`account-button `}
            >
              {t('Members')}
            </div>
          </div>
          <div className='col pl-1 '>
            <div
              className={`account-button `}
            >
              {t('Volume')}
            </div>
          </div>
        </div> */}

        <div className={styles.tableContainer}>
          <table className={` ${styles.customTable}`}>
            <thead>
              <tr>
                <th className='text-start' style={{ fontSize: '10px' }}>
                  ACCOUNT NAME
                </th>
                <th className='text-center' style={{ fontSize: '10px' }}>
                  MEMBERS
                </th>
                <th className='text-right' style={{ fontSize: '10px' }}>
                  VOLUME
                </th>
              </tr>
            </thead>
            <tbody>
              {accounts.map((account, index) => (
                <tr key={index}>
                  <td>
                    <div className='d-flex align-items-center justify-content-between w-100'>
                      <div className='d-flex align-items-center'>
                        <img src={usaFlag} alt='flag' className={styles.flag} />
                        <span className={`ms-2 ${styles.accountName}`}>{account.name}</span>
                      </div>
                      <span className={styles.statusIcon}>
                        <img
                          src={account.status === 'active' ? check : Invalid}
                          alt={account.status === 'active' ? 'Activo' : 'Inactivo'}
                          style={{ width: '30px', height: '23px' }}
                        />
                      </span>
                    </div>
                  </td>
                  <td className='text-center' style={{ fontSize: '15px' }}>
                    {account.members}
                  </td>
                  <td className='text-right' style={{ fontSize: '15px' }}>
                    {account.volume}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </ContentApp>
    </>
  );
};

export default GuestList;
